import { Price } from 'src/types';
import { filterOffersGeneric } from './filtering-generic';
import { IFilter } from './types';

export const filterOffers = (offers: Price[], filters: IFilter[]): Price[] => {
  let filteredOffers = offers;
  filters.forEach(filter => {
    filteredOffers = filterOffersGeneric(filteredOffers, filter);
  });
  return filteredOffers;
};
